// extracted by mini-css-extract-plugin
module.exports = {"quickFilters":"quick_filters_quickFilters__21Vfd"};